<template>
  <p :class="columnLayout ? 'col-lg-6' : ''" v-if="value">
    <label>{{ label }}:</label>
    <span>
      {{ agencyCurrencySign }}{{ value | twoDecimals }}
      {{ isPerHourRate ? getLabelByKeys("LABELS.PER_HOUR") : "" }}
    </span>
    <i
      v-if="isAgent && !viewOnly"
      class="material-icons edit-icon"
      @click="showUpdatePriceDialog()"
    >
      edit
    </i>
  </p>
</template>
<script>
import { FORM_TYPE } from "../../../constants/custom-define-type";
import { mapGetters } from "vuex";

export default {
  name: "PriceValueItem",
  props: {
    label: String,
    value: [Number, String],
    columnLayout: Boolean,
    isPerHourRate: {
      type: Boolean,
      default: false,
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["isAgent", "agencyCurrencySign"]),
  },
  methods: {
    showUpdatePriceDialog() {
      this.showInputDialog({
        title: "Update " + this.label,
        listFields: [{ type: FORM_TYPE.TEXTBOX, model: "value" }],
        data: {
          value: this.roundNumberTwoDigits(this.value),
        },
        onSubmitCallback: this.updatePriceValue,
      });
    },
    updatePriceValue(info) {
      this.$emit("input", info.value);
    },
  },
};
</script>

<style scoped>
.edit-icon {
  cursor: pointer;
  color: #007bff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/bookings/PriceValueItem.vue